<template>
  <div
    class="truncate pl-1 pb-1"
    style="width: 150px">
    <span class="font-bold text-gray-600">
      問題選択数 {{ selectedQuestions.length }}/{{ pagination.data.length }}
    </span>
  </div>
  <div class="shadow-lg bg-white mr-1 rounded-b-lg rounded-t">
    <div v-if="pagination.data.length">
      <data-table
        :headers="headers"
        :items="pagination.data"
        drag-disabled
        @row-click="onRowClicked">
        <template #th-checkbox>
          <input
            v-model="selectedCurrentPageQuestions"
            type="checkbox"
            class="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded focus:outline-none" />
        </template>
        <template #check_box="{ item }">
          <input
            v-model="selectedQuestions"
            :value="item.id"
            type="checkbox"
            class="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded focus:outline-none"
            @click="onClickedCheckBox" />
        </template>
        <template #field_name="{ item }">
          {{ item.field?.title ?? item.field_name }}
        </template>
        <template #question="{ item }">
          <div
            class="truncate"
            style="width: 220px">
            {{ item.question }}
          </div>
        </template>
        <template #correct_answer="{ item }">
          <div
            class="truncate"
            style="width: 200px">
            {{ item.correct_answer }}
          </div>
        </template>
        <template #status="{ item }">
          <div
            v-if="item.examinations.length"
            class="text-red-500">
            {{ statusExamination(item.examinations) }}
          </div>
        </template>
      </data-table>
      <div class="mb-5 pb-5">
        <div class="mt-4">
          <pagination
            :paginate="pagination"
            @page-previous="onPaginationChanged"
            @page-next="onPaginationChanged"
            @page-click="onPaginationChanged" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="py-4">
      <div
        class="mx-auto w-11/12 bg-red-100 border border-red-400 text-red-500 px-4 py-3 rounded relative text-center"
        role="alert">
        <span class="block sm:inline font-bold">問題が見つかりませんでした。</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import { ref, computed, watch } from 'vue'
import DataTable from '@/Common/DataTable'
import Pagination from '../../../Common/Pagination'

const props = defineProps({
  pagination: {
    type: Object,
    required: true,
  },
  subject: {
    type: Object,
    required: false,
  },
  limit: {
    type: String,
    default: '10',
  },
  subjectKeyword: {
    type: String,
    default: null,
  },
  questionKeyword: {
    type: String,
    default: null,
  },
  correctAnswerKeyword: {
    type: String,
    default: null,
  },
  isAllSubject: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['select-questions'])

const headers = {
  check_box: '',
  id: 'ID',
  field_name: '分野',
  question: '問題文',
  correct_answer: '正答',
  status: 'ステータス',
}

const selectedQuestions = ref([])
const selectedCurrentPageQuestions = computed({
  get: () => false,
  set: (bool) => {
    if (bool) {
      selectedQuestions.value = props.pagination.data.map((item) => item.id)
    } else {
      selectedQuestions.value = []
    }
  },
})
watch(
  () => selectedQuestions,
  (newVal) => {
    emit('select-questions', newVal)
  },
  { deep: true },
)
const statusExamination = (examinations) => (examinations.length ? '模試追加済' : '')

const onClickedCheckBox = (e) => e.stopPropagation()

const onRowClicked = (item, title) => {
  if (title) {
    Inertia.get(route('questions.show', {
      subject: props.subject,
      question: item,
    }),
    {
      limit: props.limit,
      page: props.pagination.current_page,
    })
  }
}

const onPaginationChanged  = (page) => {
  Inertia.get(route('questions', {
    subject: props.subject,
    page,
    limit: props.limit,
    subjectKeyword: props.subjectKeyword,
    questionKeyword: props.questionKeyword,
    correctAnswerKeyword: props.correctAnswerKeyword,
    isAllSubject: props.isAllSubject,
  }))
}
</script>
